import { createAction, props } from '@ngrx/store';

import { Survey } from '@app/core/surveys.reducer';

export const upsertSurvey = createAction('[Surveys] Upsert', props<{ survey: Survey }>());
